import React from "react";
import { Color } from "config/colors";
import styled, { css } from "styled-components";
import { CreditTabType } from "model/TipCredit";
import { FontFamily, FontSize } from "config/font";
import { Text } from "components/Typography/text.styled";

type CreditTabsProps = {
  selectedTab: CreditTabType;
  onSelectTab: (tab: CreditTabType) => void;
  depositCount: number;
  withdrawalsCount: number;
};

export const CreditTabs: React.FC<CreditTabsProps> = (props) => {
  return (
    <TipTabsStyled>
      <TipTabStyled
        active={props.selectedTab === "deposits"}
        onClick={() => props.onSelectTab("deposits")}
      >
        <Text
          fontSize={FontSize.Standard}
          fontFamily={FontFamily.MontserratSemiBold}
        >
          Deposits ({props.depositCount})
        </Text>
      </TipTabStyled>
      <TipTabStyled
        active={props.selectedTab === "withdrawals"}
        onClick={() => props.onSelectTab("withdrawals")}
      >
        <Text
          fontSize={FontSize.Standard}
          fontFamily={FontFamily.MontserratSemiBold}
        >
          Withdrawals ({props.withdrawalsCount})
        </Text>
      </TipTabStyled>
    </TipTabsStyled>
  );
};

type TabProps = {
  active: boolean;
};

export const TipTabStyled = styled.div<TabProps>`
  flex-basis: auto;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;
  border-bottom: ${(props) =>
    props.active
      ? `1px solid ${Color.Success}`
      : `1px solid ${Color.SeaBlue200}`};

  &:hover {
    background-color: ${Color.SeaBlue200};
    cursor: pointer;
  }
`;

export const TipTabsStyled = styled.div`
  width: 100%;
  display: flex;
`;
